module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.floorSet(1)
      }
    }
  }, [_vm._v("新建")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.subData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "prop": "controlFloor",
      "align": "center",
      "label": "空置楼层"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "prop": "vacantArea",
      "align": "center",
      "width": "150",
      "label": "空置面积(平方米)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "decoration",
      "width": "150",
      "align": "center",
      "label": "装修情况"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "decorationInstructions",
      "width": "180",
      "align": "center",
      "label": "装修说明"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actualUtilization",
      "align": "center",
      "width": "120",
      "label": "实际利用率"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n               " + _vm._s(scope.row.actualUtilization) + "%\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "floorHeight",
      "width": "120",
      "align": "center",
      "label": "层高(米)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "turnTowards",
      "width": "120",
      "align": "center",
      "label": "朝向"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "paymentMethod",
      "width": "120",
      "align": "center",
      "label": "交付方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "label": "报价(元/天/平方米)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(_vm._f("priceTrans")(scope.row, 1)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "propertyCosts",
      "width": "180",
      "align": "center",
      "label": "物业费用(元/天/平方米)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "label": "是否出售"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("strTrans")(scope.row.isSell)) + "\n         ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "label": "出售说明"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(_vm._f("priceTrans")(scope.row, 3)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "label": "最高售价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(_vm._f("priceTrans")(scope.row, 2)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "width": "150",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "ibtn",
          on: {
            "click": function($event) {
              _vm.floorSet(2, scope.$index)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('span', {
          staticClass: "ibtn",
          on: {
            "click": function($event) {
              _vm.floorSet(3, scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.diaState,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.diaState = $event
      },
      "closed": _vm.handleClose
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v("新建空置空间信息")])]), _vm._v(" "), _c('div', {
    staticClass: "diaContent"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "show-message": false,
      "rules": _vm.rules
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("空置位置")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "controlFloor"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "100",
      "size": "medium"
    },
    model: {
      value: (_vm.params.controlFloor),
      callback: function($$v) {
        _vm.$set(_vm.params, "controlFloor", $$v)
      },
      expression: "params.controlFloor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("空置面积（平方米）")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "vacantArea"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.vacantArea),
      callback: function($$v) {
        _vm.$set(_vm.params, "vacantArea", $$v)
      },
      expression: "params.vacantArea"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("装修情况")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "decorationId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "zxqk",
      "selectId": _vm.params.decorationId,
      "paramsKey": "decoration",
      "plaText": "装修情况"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("实际利用率（%）")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "actualUtilization"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium",
      "max": 100
    },
    model: {
      value: (_vm.params.actualUtilization),
      callback: function($$v) {
        _vm.$set(_vm.params, "actualUtilization", $$v)
      },
      expression: "params.actualUtilization"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', [_vm._v("层高（米）")])]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.floorHeight),
      callback: function($$v) {
        _vm.$set(_vm.params, "floorHeight", $$v)
      },
      expression: "params.floorHeight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', [_vm._v("装修说明")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "100",
      "size": "medium",
      "placeholder": "请输入装修情况补充说明"
    },
    model: {
      value: (_vm.params.decorationInstructions),
      callback: function($$v) {
        _vm.$set(_vm.params, "decorationInstructions", $$v)
      },
      expression: "params.decorationInstructions"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("朝向")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "turnTowardsId"
    }
  }, [_c('all-select', {
    attrs: {
      "code": "cx",
      "selectId": _vm.params.turnTowardsId,
      "paramsKey": "turnTowards",
      "plaText": "朝向"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("交付方式")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "paymentMethodId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "jffs",
      "selectId": _vm.params.paymentMethodId,
      "paramsKey": "paymentMethod",
      "plaText": "交付方式"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1), _vm._v(" "), (_vm.params.isSell != 1) ? _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("报价（元/平方米/天）")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.price),
      callback: function($$v) {
        _vm.$set(_vm.params, "price", $$v)
      },
      expression: "params.price"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("物业费（元/平方米/天）")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "propertyCosts"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.propertyCosts),
      callback: function($$v) {
        _vm.$set(_vm.params, "propertyCosts", $$v)
      },
      expression: "params.propertyCosts"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("是否出售（整栋/部分）")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isSell"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.sellChange
    },
    model: {
      value: (_vm.params.isSell),
      callback: function($$v) {
        _vm.$set(_vm.params, "isSell", $$v)
      },
      expression: "params.isSell"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.name,
        "value": item.val
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), (_vm.params.isSell == 1) ? _c('el-row', [_c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', [_vm._v("出售说明")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "20",
      "size": "medium",
      "placeholder": "请输入出售说明"
    },
    model: {
      value: (_vm.params.sellingInstructions),
      callback: function($$v) {
        _vm.$set(_vm.params, "sellingInstructions", $$v)
      },
      expression: "params.sellingInstructions"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "iTerm",
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("最高售价")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.price),
      callback: function($$v) {
        _vm.$set(_vm.params, "price", $$v)
      },
      expression: "params.price"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sellingPriceUtilId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "jgdw",
      "selectId": _vm.params.sellingPriceUtilId,
      "paramsKey": "sellingPriceUtil",
      "plaText": "价格单位"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "diaFooter"
  }, [_c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.diaState = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.goSave
    }
  }, [_vm._v("确定")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-15f09b0c"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingEdit/components/floorSave.vue
// module id = 1419
// module chunks = 1